module.exports = __webpack_public_path__ + "img/TruPath-11.ee689c87.jpg";